export default __webpack_public_path__ + "static/media/court-process-service.6ca22059.jpg";